<template>
  <div id="app">
    <Nav :is-transparent="false"></Nav>
    <Banner
      source-url="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/video/kqt.mp4"
      :isImg="false"
      title="快渠通"
      :sub-title="subTitle"
      alt-text="快渠通"
    />
    <div class="flex title-list bg-theme-light">
      <div
        :class="[
          'flex title-item',
          { active: currentIndex === index },
          { m0: index == tabList.length - 1 },
        ]"
        v-for="(item, index) in tabList"
        :key="index"
        @click="handleChange(index)"
      >
        {{ item }}
      </div>
    </div>
    <div class="flex bg-theme-light wrapper wrapper1" id="id1" ref="wrapper1">
      <div class="flex desc-box">
        <div class="desc-title">销售人员管理</div>
        <div class="desc-text">
          满足品牌销售体系下，从总部、大区经理、经销商、业代到门店的层层管理
          <br />需求。
        </div>
        <div class="flex desc-icon">
          <div class="desc-icon_box">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/1-1.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>人员组织架构管理</p>
          </div>
          <div class="desc-icon_box">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/1-2.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>门店在线签约</p>
          </div>
          <div class="desc-icon_box m0">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/1-3.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>门店信息管理</p>
          </div>
        </div>
      </div>
      <img
        class="pic"
        src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/1.png"
        alt="e店佳"
      />
    </div>
    <div class="flex wrapper wrapper2" id="id2" ref="wrapper2">
      <img
        class="pic"
        src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/2.png"
        alt="e店佳"
      />
      <div class="flex desc-box">
        <div class="desc-title">巡拍活动执行</div>
        <div class="desc-text">
          立足AI视觉识别技术，实现销售线下陈列在线审核，提高图像审核效率
          <br />和费用实投率。
        </div>
        <div class="flex desc-icon">
          <div class="desc-icon_box">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/2-1.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>生动化执行拍摄</p>
          </div>
          <div class="desc-icon_box m0">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/2-2.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>图像上传</p>
            <p>AI自动审核</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex bg-theme-light wrapper wrapper3" id="id3" ref="wrapper3">
      <div class="flex desc-box">
        <div class="desc-title">货补在线流转</div>
        <div class="desc-text">
          实现从门店端到品牌端的层层货补结算机制，提高货补透明度和发放效
          <br />率。
        </div>
        <div class="flex desc-icon">
          <div class="desc-icon_box">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/3-1.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>在线核销</p>
            <p>门店返货券</p>
          </div>
          <div class="desc-icon_box m0">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/3-2.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>支持多层级</p>
            <p>结算货补奖励</p>
          </div>
        </div>
      </div>
      <img
        class="pic"
        src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/3.png"
        alt="e店佳"
      />
    </div>
    <div class="flex wrapper wrapper4" id="id4" ref="wrapper4">
      <img
        class="pic"
        src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/4.png"
        alt="e店佳"
      />
      <div class="flex desc-box">
        <div class="desc-title">实时数据分析</div>
        <div class="desc-text">
          为各级用户提供人员管理、活动执行、费用发放等不同维度数据分析结
          <br />果，驱动智能决策。
        </div>
        <div class="flex desc-icon">
          <div class="desc-icon_box">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/4-1.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>实时数据看板</p>
          </div>
          <div class="desc-icon_box m0">
            <img
              src="https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/kqt/4-2.png"
              alt="e店佳"
              class="icon-box_img"
            />
            <p>自动化报表</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 四端在线start -->
    <SDZX></SDZX>
    <!-- 平台保障start -->
    <PTBZ></PTBZ>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue"
import Banner from "@/components/Banner.vue"
import Bottom from "@/components/Bottom.vue"
import SDZX from "@/components/SDZX.vue"
import PTBZ from "@/components/PTBZ.vue"
// import { swiper, swiperSlide } from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
import { title, description, keywords } from "./global"
export default {
  metaInfo: {
    title: title,
    meta: [
      {
        name: "keywords",
        content: keywords,
      },
      {
        name: "description",
        content: description,
      },
    ],
  },
  name: "App",
  components: {
    Nav,
    Banner,
    Bottom,
    SDZX,
    PTBZ,
    // swiper,
    // swiperSlide,
  },
  data() {
    return {
      subTitle:
        "为品牌各层级管理者提供覆盖门店、人员、活动到费用的在线管理\n工具和数字化服务，缩短管理半径，提升管理效率。",
      bannerList: [
        "https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/vmsBanner.png",
        "https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/vmsBanner.png",
      ],
      swiperOptions: {
        autoplay: true,
        speed: 1000,
        loop: true,
        // Some Swiper option/callback...
      },
      tabList: ["销售人员管理", "巡拍活动执行", "货补在线流转", "实时数据分析"],
      currentIndex: 0,
    }
  },
  methods: {
    handleChange(index) {
      this.currentIndex = index
      let offsetTop = this.$refs[`wrapper${index + 1}`].offsetTop - 88
      try {
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        })
      } catch (e) {
        window.scrollTo(0, offsetTop)
      }
    },
  },
  created() {},
}
</script>

<style lang="less" scoped>
@import url("~@/assets/global.less");
#app {
  padding-top: 88px;
}
.title-list {
  padding: 4vw 0;
  .title-item {
    position: relative;
    width: 13vw;
    height: 5.5vw;
    margin-right: 3vw;
    padding-bottom: 0.6vw;
    font-size: 1vw;
    font-weight: 400;
    color: #333333;
    background: url("https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/tabBg.png") center top
      no-repeat;
    background-size: 100% 100%;
    background-clip: content-box;
    border-radius: 4px;
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.15));
    justify-content: center;
    align-items: center;
    &:before {
      content: "";
      position: absolute;
      top: 20px;
      width: 30px;
      height: 4px;
      background: #333;
      border-radius: 2px;
    }
    &.active {
      color: #fff;
      box-shadow: none;
      background: url("https://hbrand.oss-cn-hangzhou.aliyuncs.com/new_website/tabActiveBg.png")
        top center no-repeat;
      background-size: 100% 100%;
      background-clip: border-box;
      &:before {
        background: #fff;
      }
    }
  }
}
.wrapper {
  align-items: center;
  .desc-box {
    width: 696px;
    flex-direction: column;
    font-size: 22px;
    align-items: center;
    .desc-title {
      width: 100%;
      text-align: left;
      text-align: center;
      margin-bottom: 2vw;
      font-size: 2vw;
      color: #141414;
      box-sizing: border-box;
    }
    .desc-text {
      margin-bottom: 1vw;
    }
    .desc-icon {
      justify-content: space-around;
      .desc-icon_box {
        margin-right: 4vw;
        text-align: center;
        .icon-box_img {
          width: 76px;
          margin-bottom: 1vw;
        }
        p {
          font-size: 1vw;
        }
      }
    }
  }
  .pic {
    width: 768px;
  }
  &.wrapper1 {
    padding-bottom: 2.2vw;
    padding-left: 305px;
    justify-content: flex-start;
    box-sizing: border-box;
    .desc-box {
      margin-right: 30px;
    }
    .desc-text {
      white-space: nowrap;
    }
  }
  &.wrapper2 {
    padding: 20px 0;
    .desc-box {
      margin-left: -110px;
    }
  }
  &.wrapper3 {
    padding: 20px 0 20px 305px;
    justify-content: flex-start;
    box-sizing: border-box;
    .desc-box {
      margin-right: 27px;
    }
  }
  &.wrapper4 {
    padding: 20px 0;
    .desc-box {
      margin-left: -110px;
    }
  }
}
</style>
